import { QubictronUrlBuilder } from "@qubictron/url/client";
import axios from "axios";
import { CheckAccessRequestParams } from "./query.types";
import { CheckApiAccessResponseModel } from "./response.types";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { injectDataInterceptor } from "shared/api/utils/api.utils";
import { ValueOf } from "shared/lib/typeCheck.lib";

const CHECK_API_SEA_INTEGRATION_ACCESS_API_URL = new QubictronUrlBuilder()
  .appendPathname("tracking-system/check")
  .build();
const CHECK_API_AIR_INTEGRATION_ACCESS_API_URL = new QubictronUrlBuilder()
  .appendPathname("tracking-system/check-air")
  .build();
const CHECK_API_RAIL_INTEGRATION_ACCESS_API_URL = new QubictronUrlBuilder()
  .appendPathname("tracking-system/check-rail")
  .build();
const CHECK_API_ROAD_INTEGRATION_ACCESS_API_URL = new QubictronUrlBuilder()
  .appendPathname("tracking-system/check-road")
  .build();
const CHECK_API_PARCEL_INTEGRATION_ACCESS_API_URL = new QubictronUrlBuilder()
  .appendPathname("tracking-system/check-parcel")
  .build();

const checkApiURLsMap: Record<ValueOf<typeof ShipmentType>, string> = {
  [ShipmentType.SEA]: CHECK_API_SEA_INTEGRATION_ACCESS_API_URL,
  [ShipmentType.AIR]: CHECK_API_AIR_INTEGRATION_ACCESS_API_URL,
  [ShipmentType.RAIL]: CHECK_API_RAIL_INTEGRATION_ACCESS_API_URL,
  [ShipmentType.ROAD]: CHECK_API_ROAD_INTEGRATION_ACCESS_API_URL,
  [ShipmentType.PARCEL]: CHECK_API_PARCEL_INTEGRATION_ACCESS_API_URL,
};

const requestInstance = axios.create();
injectDataInterceptor(requestInstance);

class ApiAccessService {
  public checkAccess({ platformId, shipmentType }: CheckAccessRequestParams): Promise<CheckApiAccessResponseModel> {
    requestInstance.defaults.baseURL = checkApiURLsMap[shipmentType];
    return requestInstance.get("", { params: { platform_id: platformId } });
  }
}

const apiAccessService = new ApiAccessService();

export { apiAccessService };
